// extracted by mini-css-extract-plugin
export default {"entityPageContainer":"EntityPage_entityPageContainer__AiM8C","scrollContent":"EntityPage_scrollContent__NE4RY","anchorMenu":"EntityPage_anchorMenu__UhllT"};